import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import * as fromComponents from './components';
import * as fromDirectives from './directives';
import { SharedControlsMaterialModule } from './material/shared-controls-material.module';
import * as fromPipes from './pipes';

@NgModule({
  declarations: [
    ...fromComponents.components,
    ...fromPipes.pipes,
    ...fromDirectives.directives
  ],
  imports: [
    CommonModule,
    SharedControlsMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslatePipe,
    InfiniteScrollModule,
    ImageCropperComponent,
    PdfViewerModule
  ],
  exports: [
    ...fromComponents.components,
    ...fromPipes.pipes,
    ...fromDirectives.directives
  ]
})
export class SharedComponentsModule {}
